module.exports = __webpack_public_path__ + "img/icon-zonghe.6f61a107.svg";